module.exports = __webpack_public_path__ + "img/92133.9c5fff8e.svg";